import React, { useEffect } from 'react';
import SalesLandingPage from './components/SalesLandingPage';
import VideoDemoPortal from './components/VideoDemoPortal';
import AboutSupportSection from './components/AboutSupportSection';
import { landingConfig } from './config/landingConfig';
import './App.css';

landingConfig.faqItems = (landingConfig.faqItems || []).map((faq) => ({
  ...faq,
  question: faq.question || faq.q,
  answer: faq.answer || faq.a,
}));

function App() {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.has('license_key') || params.has('licence_key')) {
      const target = new URL(landingConfig.existingUserAppUrl);
      params.forEach((value, key) => target.searchParams.set(key, value));
      window.location.replace(target.toString());
    }
  }, []);

  return (
    <>
      <SalesLandingPage />
      <VideoDemoPortal />
      <AboutSupportSection />
    </>
  );
}

export default App;